"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHostManifestBuilder = void 0;
var assets_1 = require("../../toolbox/assets");
var componentsManifestBuilder_1 = require("./componentsManifestBuilder");
function createHostManifestBuilder(_a) {
    var host = _a.host;
    var hostManifest = {
        host: host,
        assets: [],
        components: {},
        statics: {},
    };
    var componentBuilders = {};
    return {
        addUrl: function (id, url) {
            hostManifest.id = id;
            hostManifest.url = url;
            this.addModelAsset(id, url);
            return this;
        },
        addComponentStatics: function (componentName, statics) {
            hostManifest.statics[componentName] = statics;
            return this;
        },
        addRuntimeAsset: function (url) {
            hostManifest.assets.push({
                url: url,
                type: 'webpack-runtime',
                extension: 'js',
            });
            return this;
        },
        addHotAsset: function (url) {
            hostManifest.assets.push({
                url: url,
                type: 'hot',
                extension: 'js',
            });
            return this;
        },
        addModelAsset: function (id, url) {
            hostManifest.assets.push({
                id: id,
                url: url,
                type: 'model',
                extension: 'js',
            });
            return this;
        },
        addStyleAsset: function (url) {
            hostManifest.assets.push({
                url: url,
                type: 'style',
                extension: 'css',
            });
            return this;
        },
        getComponentBuilder: function (name) {
            if (!componentBuilders[name]) {
                componentBuilders[name] = componentsManifestBuilder_1.createComponentManifestBuilder({
                    name: name,
                });
            }
            return componentBuilders[name];
        },
        addDeps: function (deps) {
            var _a;
            hostManifest.deps = deps.filter(function (url) { return assets_1.isJS(assets_1.getExtension(url)); });
            (_a = hostManifest.assets).push.apply(_a, deps.map(function (url) {
                var extension = assets_1.getExtension(url);
                return {
                    url: url,
                    type: assets_1.getAssetsTypeByExtension(extension),
                    extension: extension,
                    dependency: true,
                };
            }));
        },
        build: function () {
            var state = __assign({}, hostManifest);
            var components = {};
            Object.keys(componentBuilders).forEach(function (componentName) {
                components[componentName] = componentBuilders[componentName].build();
            });
            return __assign(__assign({}, state), { components: components });
        },
    };
}
exports.createHostManifestBuilder = createHostManifestBuilder;
//# sourceMappingURL=hostManifestBuilder.js.map